import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
} from "@mui/material";
import { Field, useFormikContext } from "formik";
import { RadioGroup } from "formik-mui";
import * as Yup from "yup";
import { getBooleanValue } from "@poseidon/utils/getBooleanValue";
import { useMemo } from "react";
import { EditSailorFormPanel } from "./EditSailorFormPanel";

function ConsentFieldsInner({ readonly }) {
  const { values } = useFormikContext();
  return (
    <Grid container spacing={2} mt={0}>
      <Grid item xs={12} sm={6}>
        <FormControl disabled={readonly}>
          <FormLabel>KYC/AML Checks</FormLabel>
          <Field component={RadioGroup} name="kycAmlConsent">
            <FormControlLabel
              value={null}
              control={<Radio />}
              label="Unanswered"
              checked={
                values.kycAmlConsent === "" || values.kycAmlConsent === null
              }
            />
            <FormControlLabel value={true} control={<Radio />} label="Yes" />
            <FormControlLabel value={false} control={<Radio />} label="No" />
          </Field>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl disabled={readonly}>
          <FormLabel>Open Banking Checks</FormLabel>
          <Field component={RadioGroup} name="openBankingConsent">
            <FormControlLabel
              value={null}
              control={<Radio />}
              label="Unanswered"
              checked={
                values.openBankingConsent === "" ||
                values.openBankingConsent === null
              }
            />
            <FormControlLabel value={true} control={<Radio />} label="Yes" />
            <FormControlLabel value={false} control={<Radio />} label="No" />
          </Field>
        </FormControl>
      </Grid>
    </Grid>
  );
}

const sailorDefaults = {
  kycAmlConsent: null,
  openBankingConsent: null,
};

export const validationSchema = Yup.object().shape({
  //todo: validation
});

const mapValues = (values) => {
  return {
    ...values,
    kycAmlConsent: getBooleanValue(values.kycAmlConsent),
    openBankingConsent: getBooleanValue(values.openBankingConsent),
  };
};
export function ConsentFields({ sailor, readonly }) {
  const initialValues = useMemo(
    () => ({
      ...sailorDefaults,
      ...sailor,
    }),
    [sailor]
  );
  return (
    <EditSailorFormPanel
      title="Consent Details"
      disabled={readonly}
      initialValues={initialValues}
      mapValues={mapValues}
      validationSchema={validationSchema}
      sailor={sailor}
    >
      <ConsentFieldsInner readonly={readonly} />
    </EditSailorFormPanel>
  );
}
